import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { LangSwitch } from "./LangSwitch";
import { AccountButton } from "./AccountButton";
import { useLang } from "@/lib/i18n";

export const NAV = [
  ["/", "nav.home", "nav-link-inicio"],
  ["/explorar", "nav.explore", "nav-link-explorar"],
  ["/salas", "nav.rooms", "nav-link-salas"],
  ["/catalogo", "nav.catalog", "nav-link-catalogo"],
  ["/coleccion", "nav.collection", "nav-link-coleccion"],
  ["/noticias", "nav.news", "nav-link-noticias"],
  ["/comunidad", "nav.community", "nav-link-comunidad"],
  ["/que-es-mutoni", "nav.about", "nav-link-que-es-mutoni"],
];

const HEADER_NAV = NAV.filter(([to]) => to !== "/salas");

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const { t } = useLang();
  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-[rgba(13,12,10,0.78)] backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-[72px] max-w-[1440px] items-center justify-between px-5 md:px-10">
        <Link to="/" data-testid="header-logo"><Logo /></Link>
        <nav className="hidden items-center gap-5 xl:flex">
          {HEADER_NAV.map(([to, label, id]) => (
            <NavLink key={to} to={to} end={to === "/"} data-testid={id} className={({ isActive }) => `nav-link ${isActive ? "nav-on" : ""}`}>
              {t(label)}
            </NavLink>
          ))}
          <LangSwitch />
          <AccountButton />
          <Link to="/explorar?mode=3d" className="btn-primary !py-2" data-testid="nav-cta-3d">{t("nav.cta3d")}</Link>
        </nav>
        <div className="flex items-center gap-2 xl:hidden">
          <LangSwitch className="lang-compact" prefix="mobile-" />
          <AccountButton prefix="mobile-" />
          <button className="icon-btn" onClick={() => setOpen((o) => !o)} aria-label={t("nav.menu")} data-testid="mobile-menu-toggle">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="max-h-[calc(100vh-72px)] overflow-y-auto border-t border-white/10 bg-[var(--bg)] px-5 py-6 xl:hidden" data-lenis-prevent data-testid="mobile-menu">
          {HEADER_NAV.map(([to, label, id]) => (
            <Link key={to} to={to} className="block py-3 font-display text-4xl" data-testid={`mobile-${id}`}>{t(label)}</Link>
          ))}
          <Link to="/explorar?mode=3d" className="btn-primary mt-4" data-testid="mobile-nav-cta-3d">{t("nav.cta3d")}</Link>
        </nav>
      )}
    </header>
  );
};
